import React from "react";
import { i18n } from '../../../lang/i18n';
import icon from '../../../static/logo-pdf.png'
import jsPDF from 'jspdf';
import HelperProducts from "../../../common/HelperProducts";

interface Props {
    item: any,
    productExtras: any,
    locationLegal:any
}

export default function UserInvoiceToPDF(props: Props) {
    function jsPdfGenerator() {
        const item = props.item;
        // Example From https://parall.ax/products/jspdf
        // https://artskydj.github.io/jsPDF/docs/jsPDF.html#line
        let w = 400;
        let doc = new jsPDF('p', 'pt', [400, 600]);

        let lineHeight = 19;
        let currentY = 20;
        let currentX = 20;

        doc.setFont('time')
        doc.setFontSize(12)
        lineHeight = 15;

        doc.addImage(icon, 'png', 100, currentY, 200, 50)
        currentY += 70;
        doc.text(props.locationLegal.name, currentX, currentY)
        doc.text(i18n.PDF.INVOICE, 350, currentY, { align: 'right' })
        currentY += lineHeight;
        doc.text(props.locationLegal.address1, currentX, currentY)
        doc.text(item.invoiceNumber, 350, currentY, { align: 'right' })
        currentY += lineHeight;
        doc.text(props.locationLegal.address2, currentX, currentY)
        doc.text(item.invoiceDate, 350, currentY, { align: 'right' })
        currentY += lineHeight;
        doc.text(props.locationLegal.vatNumber, currentX, currentY)
        currentY += lineHeight;
        doc.line(20, currentY, w - 40, currentY)

        currentY += lineHeight;
        doc.text(i18n.PDF.QUANTITY, 50, currentY, { align: 'right' })
        doc.text(i18n.PDF.PRODUCT, 55, currentY)
        doc.text('€', 350, currentY, { align: 'right' })
        currentY += 8;
        doc.line(20, currentY, w - 40, currentY);

        for (let x = 0; x < item.products.length; x++) {
            currentY += lineHeight + 5;
            doc.text('' + item.products[x].quantity, 50, currentY, { align: 'right' })
            const lines = HelperProducts.ProductDescriptionPrint(props.productExtras, item.products[x])
            let title = lines[0].length > 45 ? lines[0].substr(0, 45) + '...' : lines[0];
            doc.text(title, 55, currentY, { maxWidth: 0 })
            doc.text(item.products[x].price.toFixed(2) + " €", 350, currentY, { align: 'right' })
            for (let l = 1; l < lines.length; l++) {
                currentY += lineHeight;
                doc.text(lines[l], 55, currentY, { maxWidth: 0 })
            }
        }
        currentY += lineHeight;
        doc.line(20, currentY, w - 30, currentY)
        currentY += lineHeight;
        doc.text(i18n.PDF.VAT + ' ' + item.totalPriceNet.toFixed(2) + "€", 350, currentY, { align: 'right' })
        currentY += lineHeight;
        doc.text(i18n.PDF.Net + ' ' + item.totalPriceNet.toFixed(2) + "€", 350, currentY, { align: 'right' })
        currentY += lineHeight;
        doc.text(i18n.PDF.Total + ' ' + item.totalPrice.toFixed(2) + "€", 350, currentY, { align: 'right' })

        // Save the Data
        doc.save(i18n.PDF.INVOICE + ".pdf")
    }

    return (
        <button onClick={jsPdfGenerator} className="btn btn-outline-secondary btn-sm w-50">PDF</button>
    );
}




